"use client"
import React from 'react'
import { createContext, useState } from 'react';
import { StartGame, StartGameForFun } from '../services/games';
import { useContext } from 'react';
import { AppContext } from './AppContext';

export const GameContext = createContext();

export const GameContextProvider = ({ children }) => {
  const { isMobile, user, setPageLoader } = useContext(AppContext);
  const [isIframeVisible, setIsIframeVisible] = useState(false);
  const [gameUrl, setGameUrl] = useState(null);
  const [gameLoader, setGameLoader] = useState(false);
  const [selectedGame, setSelectedGame] = useState(null);
  const startGame = (gameId, machineId, gameName, navigate) => {
    setGameLoader(true);
    if (user) {
      if (gameId) setPageLoader(true);
      StartGame({
        gameId: selectedGame?.gameId ?? gameId,
        machineId: selectedGame?.machineId ?? machineId,
        gameName: selectedGame?.displayName ?? gameName,
      })
        .then((response) => {
          setIsIframeVisible(true);
          setGameUrl(response);
          if (gameId) {
            navigate();
          }
          isMobile && Tawk_API.hideWidget();
        })
        .catch((error) => { })
        .finally(() => {
          setGameLoader(false);
          setPageLoader(false);
        });
    } else {
      StartGameForFun({
        gameId: selectedGame?.gameId,
        machineId: selectedGame?.machineId,
        gameName: selectedGame?.displayName,
      })
        .then((response) => {
          setIsIframeVisible(true);
          setGameUrl(response);
          isMobile && Tawk_API.hideWidget();
        })
        .catch((error) => { })
        .finally(() => setGameLoader(false));
    }
  };

  const values = {
    isIframeVisible,
    setIsIframeVisible,
    gameUrl,
    setGameUrl,
    gameLoader,
    setGameLoader,
    selectedGame,
    setSelectedGame,
    startGame
  }

  return (
    <GameContext.Provider value={values}>
      {children}
    </GameContext.Provider>
  )
}